export default __webpack_public_path__ + "static/media/bg-contact.4f68c487.svg";